export default "__VITE_ASSET__B16UXe91__"